import { render, staticRenderFns } from "./MoveSubjectDialog.vue?vue&type=template&id=1c84b0e8&"
import script from "./MoveSubjectDialog.ts?vue&type=script&lang=ts&"
export * from "./MoveSubjectDialog.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports